module.exports = __webpack_public_path__ + "img/wave.fb7f740e.svg";